<template>
  <v-card class="mx-auto">
    <v-card-title>{{ $t("products.sessions.sessionForm.titleForm") }}</v-card-title>
    <v-card-text>
      <v-card outlined class="pa-4 mb-6">
        <v-row>
          <v-col md="8" sm="12">
            <v-row>
              <v-col>
                <v-text-field @change="v$.form.title.$touch()" :error-messages="titleErrors" @blur="v$.form.title.$touch()" required :label="`${$t('products.sessions.sessionForm.title')} *`"
                  v-model="form.title"></v-text-field>
                  <v-text-field readonly :label="`${$t('products.sessions.sessionForm.order')}`"
                  v-model="form.order"></v-text-field>
                  <v-switch :label="form.status ? `${$t('products.sessions.sessionForm.statusTrue')}` : `${$t('products.sessions.sessionForm.statusFalse')}`" v-model="form.status"></v-switch>
              </v-col>
            </v-row>

          </v-col>
        </v-row>
      </v-card>



      <v-row class="pb-6">
        <v-col cols="12" md="12">
          <v-row>

            <v-col>

                <v-card outlined>
                  <v-card-title>
                    <div class="d-flex">
                      
                      <div>
                        <div class="text-h4" v-if="form.asus">{{ form.asus.length }}</div>
                      </div>
                      
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <div class="font-weight-bold">
                      {{ $t("products.sessions.sessionForm.formats") }}
                    </div>
                  </v-card-text>
                </v-card>
              
            </v-col>
            <v-col>
              <v-card outlined>
                <v-card-title>
                  <div class="d-flex">
                    
                   
                    <div>
                      <div class="text-h4" v-if="form.asus">{{ form.packs.length }}</div>
                    </div>
                  </div>
                </v-card-title>
                <v-card-text>
                  <div class="font-weight-bold">
                    {{ $t("products.sessions.sessionForm.packs") }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card>
            <h3 class="py-3 px-5">Selecione abaixo as ASUs que estarão nesta sessão:</h3>
            <v-data-table dense class="dense-table"
            :headers="asusTable.headers" :items="asus" :items-per-page="5" :search="searchAsus"
            :sort-by="asusSortBy" :sort-desc="asusSortDesc">
            <template v-slot:[`item.sku`]="{ item }">
              <v-checkbox v-model="form.asus" :value="item.sku"></v-checkbox>
            </template>
            
          
            <template v-slot:[`item.computed.formatText`]="{ item }">
              {{ item._format }} -
              <span v-for="(bucket, bucketIndex) in item.buckets" :key="bucketIndex"><strong>{{ bucket.title }}: </strong>{{
                bucket.name }}</span>
            </template>
            <template v-slot:[`item.rules.pricing.price`]="{ item }">
              <span class="mx-4">{{
                $n(item.rules.pricing.price, "currency")
              }}</span>
            </template>
            <template v-slot:[`item.createdOn`]="{ item }">
              {{ item.computed.createdOn | dateTime }}
            </template>
            <template v-slot:[`item.computed.locationsText`]="{ item }">
              <span v-html="item.computed.locationsText"></span>
            </template>
    
            <template v-slot:[`item.status`]="{ item }">
              <v-chip label small class="mx-2" v-if="item.status" color="success">{{
                $t("products.ASUS.asuList.active")
              }}</v-chip>
              <v-chip label small class="mx-2" v-else>{{
                $t("products.ASUS.asuList.inactive")
              }}</v-chip>
            </template>
            <template v-slot:[`item.buckets`]="{ item }">
              {{ setBuckets(item.buckets) }}
            </template>
         
            
          </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card>
            <h3 class="py-3 px-5">Selecione abaixo os Pacotes que estarão nesta sessão:</h3>
            <v-data-table dense class="dense-table"
            :headers="packsTable.headers" :items="packs" :items-per-page="5" :search="searchPacks"
            :sort-by="packSortBy" :sort-desc="packSortDesc">
           
            
            <template v-slot:[`item.image`]="{ item }">
              <v-checkbox v-model="form.packs" :value="item.id"></v-checkbox>
              <v-avatar size="32">
                <v-img :srcl="item.image"></v-img>
              </v-avatar>
              
            </template>
            <template v-slot:[`item.name`]="{ item }">
              {{ item.name }}
              
            </template>
            <template v-slot:[`item.coverage`]="{ item }">
              {{ joinItems(item.coverage)  }}
            </template> 
            <template v-slot:[`item.finalPrice`]="{ item }">
              {{ $n(item.finalPrice, 'currency') }}
            </template>
            <template v-slot:[`item.asus`]="{ item }">
              {{ $n(item.asus.length) }}
            </template>
            <template v-slot:[`item.createdOn`]="{ item }">
              {{ item.computed.createdOn | dateTime }}
            </template>
           
    
            <template v-slot:[`item.status`]="{ item }">
              <v-chip label small class="mx-2" v-if="item.status == 'published'" color="success">{{
                $t("products.ASUS.asuList.active")
              }}</v-chip>
              <v-chip label small class="mx-2" v-else>{{
                $t("products.ASUS.asuList.inactive")
              }}</v-chip>
            </template>
            
         
            
          </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      
         
      <v-divider class="my-6"></v-divider>
      <v-row>
        <v-col class="d-flex">
          <v-btn icon color="error" :disabled="!form.id" @click="removePack = true">
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text large @click="$emit('show-form', false)">{{
            $t("products.packages.packForm.cancel")
          }}</v-btn>
          <v-btn color="success" :loading="processing" elevation="0" large :disabled="titleErrors.length > 0"
            @click="save()">{{
              $t("products.packages.packForm.save") }}</v-btn>
        </v-col>
      </v-row>

    </v-card-text>
    <v-dialog v-model="removePack" width="540">
      <v-card class="mx-auto">
        <v-card-title>
          <div class="d-flex">
            <span>Tem certeza que deseja remover esta sessão permanentemente?</span>
            <!-- <v-btn @click="removePack = false" icon><v-icon>mdi-close</v-icon></v-btn> -->
          </div>
        </v-card-title>
        <v-card-text>
          <div class="d-flex">
            <v-spacer></v-spacer>
            <v-btn @click="removePack = false" text>{{ $t('common.cancel') }}</v-btn>
            <v-btn @click="remove()" color="error" elevation="0">{{ $t('common.remove') }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import moment from "moment";
import config from "@/store/config";
import { initializeApp } from "firebase/app";
import useVuelidate from "@vuelidate/core";
import { required } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";

import {
  getFirestore,
  collection,
  query,
  where,
  deleteDoc,
  getDocs,
  doc,
  setDoc,
} from "firebase/firestore";

export default {
  
  setup() {
    return { v$: useVuelidate() };
  },

  validations: {
    form: {
      title: {required}
    },
  },

  name: "SessionForm",

  data: () => ({
    asusSortBy: "",
    packSortBy: "",
    asusSortDesc: true,
    packSortDesc: true,
    searchPacks: "",
    searchAsus: "",
    removePack: false,
    processing: false,
    asusTable: {
      documents: [],
      headers: []
    },
    packsTable: {
      documents: [],
      headers: []
    },
    form: {
      title: "",
      packs: [],
      asus: [],
      status: false,
      order: 0
    },
    model: {
      title: "",
      packs: [],
      asus: [],
      status: false,
      order: 0
    },

  }),
  props: {
    snap: [Object, null],
    show: Boolean,
    asus: Array,
    packs: Array
  },
  computed: {
    ...mapState("groupStores", [
      "masterStore"]
    ),

    
    titleErrors() {
      const errors = [];
      if (!this.v$.form.title.$dirty) return errors;
      
      this.v$.form.title.required.$invalid &&
        errors.push(this.$t("Este campo é obrigatório"));
      return errors;
    }
  },
  watch: {
   
    snap: {
      deep: true,
      handler(value) {
        const v = JSON.parse(JSON.stringify(value))
        if (v && Object.keys(v).length) {
          console.log("v", v);
          if (!v.hasOwnProperty("updatedOn")) {
           v.updatedOn = moment().format()
          }
          if (!v.hasOwnProperty("createdOn")) {
            v.createdOn = moment().format()
          }
        }
      },
    },
    
    // 'form.hasValidate'(val){
    //         this.form.hasLimitPlacement = val
    // },
    // 'form.hasLimitPlacement'(val){
    //     if(val){
    //         this.form.hasValidate = val
    //     }
    // }
  },
  mounted() {
    this.packsTable.headers = [
      {
                    text: "",
                    align: "start",
                    sortable: true,
                    value: "image",
                },
                {
                    text: this.$t('products.packages.name'),
                    align: "start",
                    sortable: false,
                    value: "name",
                },
                {
                    text: this.$t('products.packages.coverage'), value: "coverage", sortable: false,
                },
                {
                    text: this.$t('products.packages.finalPrice'), value: "finalPrice", sortable: false,
                },
             
              
                {
                    text: this.$t('products.packages.asus'), value: "asus", sortable: false,
                },
               
                {
                    text: this.$t('products.packages.status'), value: "status", sortable: false,
                },
                {
                    text: this.$t('products.packages.updatedOn'), value: 'updatedOn', sortable: false
                },
                // {
                //     text: "", value: "id", sortable: false,
                // }
    ]
    this.asusTable.headers = [
        {
          text: this.$t("products.ASUS.asuList.asuTitle"),
          value: "sku",
          align: "center",
        },
        {
          text: this.$t("products.ASUS.asuList.formatTitle"),
          value: "computed.formatText",
        },
        {
          text: this.$t("products.ASUS.asuList.finalPrice"),
          value: "rules.pricing.price",
        },
       
        {
          text: this.$t("products.ASUS.asuList.coverage"),
          value: "computed.coverage",
        },

        {
          text: this.$t("products.ASUS.asuList.status"),
          align: "center",
          sortable: true,
          value: "status",
        },
        {
          text: this.$t("products.ASUS.asuList.buckets"),
          align: "start",
          sortable: true,
          value: "buckets",
        },
        {
          text: this.$t("products.ASUS.asuList.createAd"),
          align: "start",
          sortable: true,
          value: "createdOn",
        },
      ]
    if (this.snap) {
      const v = JSON.parse(JSON.stringify(this.snap));
      if (v && Object.keys(v).length) {
        this.form = v;
      } else {
        this.form = JSON.parse(JSON.stringify(this.model));
      }
     
      if (!v.hasOwnProperty("updatedOn")) {
        this.form.updatedOn = moment().format()
      }
      if (!v.hasOwnProperty("createdOn")) {
        this.form.createdOn = moment().format()
      }
    }
    
  },
  methods: {
    ...mapActions("snackbar", ["showSnack"]),
    joinItems(items) {
            if (Array.isArray(items)) {
                return items.join(', ')
            }
            else
                return ''
        },
    remove() {
      const firebase = initializeApp(config)
      const db = getFirestore(firebase);
      deleteDoc(doc(db, "productSessions", this.form.id)).then(() => {
        this.showSnack({
          text: this.$t("products.sessions.removed"),
          color: "success",
          timeout: 3800,
          icon: "mdi-check",
        });
        this.$emit('reload-documents', true)
      })
    },
    setBuckets(bucket) {
      let buckets = [];
      bucket.forEach((item) => {
        buckets.push(`${item.title}: ${item.name}`);
      });
      return buckets.join(', ');
    },
   


    save() {
      console.log('call to save...');
      this.processing = true;
      const Form = this.form;

      if (!this.form.id) Form.createdOn = moment().format();
      Form.id = this.form.id ? this.form.id : `ses${moment().format("X")}`;

     
      Form.updatedOn = moment().format()
      
      const firebase = initializeApp(config);
      const db = getFirestore(firebase);
      setDoc(doc(db, "productSessions", Form.id), Form).then(() => {
        this.processing = false;
        this.showSnack({
          text: this.$t("products.sessions.saved"),
          color: "success",
          timeout: 3800,
          icon: "mdi-check",
        });
        // this.form = JSON.parse(JSON.stringify(this.snap))
        this.saved = true;
        this.$emit("reload-documents", true);
      });

    }
  },
};
</script>
